import PanelForm from './../panel/Form'
import styles from './Form.module.css';
import React, {useState} from "react";

function Form() {


    const [selectedIndex, setSelectedIndex] = useState(0);

    const HELLO = (props) => (
        <div>
            {props.items.map( (item, index) => (
                <div className={styles.item} onClick={() => index == selectedIndex ? setSelectedIndex(-1) : setSelectedIndex(index)}>
                    <table>
                        <tbody>
                        <tr >
                            <td style={{width: '100%'}}>{item.question}</td>
                            <td style={{color: '#62a615'}}>{selectedIndex == index ? '-' : '+'}</td>
                        </tr>
                        </tbody>
                    </table>
                    {selectedIndex == index && (
                        <div className={styles.itemContent}>
                            {item.answer}
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
  return (
      <div className="wrapper">
          <PanelForm style={{background: '#FFFFFF', padding: 25}}>
              <h1>Häufig gestellte Fragen</h1>
          </PanelForm>
          <br/>
          <HELLO items={[
              {
                  question: "Test?",
                  answer: (
                      <p className="m-0">
                          test
                      </p>
                  )
              }
          ]}/>
      </div>
  );
}

export default Form;
